if (typeof window !== 'undefined') {
	const deviceCheck = function() {
		const isMac = (() => {
			if (navigator.userAgentData.platform) {
				return navigator.userAgentData.platform.toLowerCase().includes('mac');
			}
			return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
		})();

		const addClass = () => {
			if (isMac) {
				document.documentElement.classList.add('os-mac');
			}
		};

		const init = () => {
			addClass();
		};

		return {
			isMac,
			init,
		};
	};

	window.addEventListener('load', function() {
		window.DeviceCheck = deviceCheck();
		window.DeviceCheck.init();
	});
}



// WEBPACK FOOTER //
// ./src/common/DeviceCheck/DeviceCheck.js